import { UserLoan } from '@matech/thebigpos-sdk'
import PrequalPNG from 'assets/lordicons/Questionnaire.png'
import PrequalGIF from 'assets/lordicons/QuestionnaireAnimated.gif'
import { navigationLinking } from './navigation'
import { FixMeLater, InviteActionsProps } from '../types'
import { isJsonString } from './utils'

export const filterUserLoansByRoles = (
	userLoans: UserLoan[],
	roles: UserLoan['role'][]
) => {
	if (!userLoans) return []
	return userLoans.filter((userLoan) => {
		const userRole = userLoan.role
		return roles.includes(userRole)
	})
}

export const truncatedUserLoans = (userLoans: UserLoan[]) => {
	const remaining = 0
	if (userLoans.length > 1) {
		return {
			userLoans: userLoans.slice(0, 1),
			remaining: userLoans.length - 1,
		}
	}

	return { userLoans, remaining }
}

export const addSpacesToPascalCase = (str: string) => {
	return str.replace(/([a-z])([A-Z])/g, '$1 $2')
}

export const getNameExtensionFromFileName: (fileName: string) => {
	name: string
	extension: string
} = (fileName: string) => {
	const fileNameToArray = fileName.split('.')
	const extension =
		fileNameToArray.length > 1 ? fileNameToArray.pop() ?? '' : ''
	const name = fileNameToArray.join('_') // Join with underscore to avoid issues with extra periods in file names

	return { name, extension }
}

export const inviteActions: InviteActionsProps = {
	Borrower: [
		{
			name: 'Apply for a Loan',
			id: 'fullApp',
			staticIcon: PrequalPNG,
			animatedIcon: PrequalGIF,
			route:
				navigationLinking.Apply as keyof typeof navigationLinking,
			description: 'Continue in English',
		},
		{
			name: 'Solicitar un Préstamo',
			id: 'spanishFullApp',
			staticIcon: PrequalPNG,
			animatedIcon: PrequalGIF,
			route:
				navigationLinking.ApplySpanish as keyof typeof navigationLinking,
			description: 'Continuar en Español',
		},
	],
	CoBorrower: [
		{
			name: 'Co-Borrower Application',
			id: 'fullApp',
			staticIcon: PrequalPNG,
			animatedIcon: PrequalGIF,
			route:
				navigationLinking.InviteApply as keyof typeof navigationLinking,
			description: 'Continue in English',
		},
		{
			name: 'Solicitud de Coprestatario',
			id: 'spanishFullApp',
			staticIcon: PrequalPNG,
			animatedIcon: PrequalGIF,
			route:
				navigationLinking.InviteApplySpanish as keyof typeof navigationLinking,
			description: 'Continuar en Español',
		},
	],
}

export const getValidFormJson = (formJson: string | FixMeLater[]) => {
	if (typeof formJson === 'string') {
		return isJsonString(formJson) ? JSON.parse(formJson) : []
	}
	if (Array.isArray(formJson)) {
		return formJson
	}

	return []
}

export const removeConsecutiveDashesUnderscores = (
	fileName: string
) => {
	return fileName
		.replace(/-+/g, '-')
		.replace(/(_-)|(-_)/g, '_')
		.replace(/_+/g, '_')
}

export const replaceSpecialCharsWithDashes = (fileName: string) => {
	return removeConsecutiveDashesUnderscores(
		fileName.replace(/[^a-zA-Z0-9-_]/g, '-').replace(/-$/, '')
	)
}
